import React, { useContext, useEffect, useState } from 'react'
import { StateController } from './../../App';
import { sendDataLayer } from '../../utils/functions'

function Profile({
  nickname,
  defaultLetter
}) {
  
  const { context } = useContext(StateController);
  const [letters, setLetters] = useState('')
  const [winner, setWinner] = useState(false)


  useEffect(() => {
    
    if (nickname) {
      const names = nickname.split(' ')

      if (names[0][0]) {
        setLetters(
          `${names[0][0]}${names[1] ? names[1][0] : ''}`
        )
      } else {
        setLetters(
          defaultLetter
        )
      }
      
    }
  }, [nickname])

  useEffect(() => {
    if (context && context.tracing && context.tracing.winner_1 === 1) {
      setWinner(true)
    }
  }, [context])

  const clickCintillaWinner = () => {
    sendDataLayer({datalayer: {event: 'notification_bar',text: "e-gift Card disponible" ,link: "/GanaConMastercardDebit/premios"},repeat: true})
  }
  
  return (
    <div className={`mc-profile-card`}>
      <div className={`mc-profile-avatar`}>
        <div className={`mc-profile-avatar__letters slow_ani`}>{letters}</div>
      </div>
      <div className={`mc-profile-name slow_ani`}>Hola{nickname ? ',' : ''} {nickname}{winner && <>, tienes una <a onClick={clickCintillaWinner} href="/GanaConMastercardDebit/premios">e-Gift Card disponible</a></>}</div>
    </div>
  )
}

export default Profile